export const parentsRouter = [
  {
    path: "examination-result",
    name: "examination-result",
    component: () => import("@/views/examination-result/examination-result.vue"),
    meta: {
      title: "遨游结果",
      noCache: true
    }
  },
  {
    path: "principalMailBox",
    name: "principalMailBox",
    component: () => import("@/views/principal-mailbox/principalMailBox/principalMailBox.vue"),
    meta: {
      title: "校长信箱",
      noCache: true
    }
  },
  {
    path: "message",
    name: "message",
    component: () => import("@/views/principal-mailbox/message/message.vue"),
    meta: {
      title: "给校长留言",
      noCache: true
    }
  },
  {
    path: "message-detail",
    name: "message-detail",
    component: () => import("@/views/principal-mailbox/message-detail/message-detail.vue"),
    meta: {
      title: "留言详情",
      noCache: true
    }
  },
  {
    path: "submitMessage-success",
    name: "submitMessage-success",
    component: () => import("@/views/principal-mailbox/submitMessage-success/submitMessage-success.vue"),
    meta: {
      title: "提交成功",
      noCache: true
    }
  },
  {
    path: "logistics-inquiry",
    name: "logistics-inquiry",
    component: () => import("@/views/logistics-inquiry/logistics-inquiry.vue"),
    meta: {
      title: "讲义物流查询"
    }
  },
  {
    path: "monthly-report",
    name: "monthly-report",
    component: () => import("@/views/monthly-report/monthly-report.vue"),
    meta: {
      title: "学习月报"
    }
  },
  {
    path: "student-end-report",
    name: "student-end-report",
    component: () => import("@/views/monthly-report/student-end-report.vue"),
    meta: {
      title: "结课报告"
    }
  },
  {
    path: "invited-parents-step1",
    name: "Invited-parents-step1",
    component: () => import("@/views/invited-parents/invited-parents-step1/invited-parents-step1.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "invited-parents-step2",
    name: "Invited-parents-step2",
    component: () => import("@/views/invited-parents/invited-parents-step2/invited-parents-step2.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "invited-parents-step3",
    name: "Invited-parents-step3",
    component: () => import("@/views/invited-parents/invited-parents-step3/invited-parents-step3.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "invited-parents-step4",
    name: "Invited-parents-step4",
    component: () => import("@/views/invited-parents/invited-parents-step4/invited-parents-step4.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "all-followed",
    name: "all-followed",
    component: () => import("@/views/invited-parents/special-status/all-followed/all-followed.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "focus-failure",
    name: "focus-failure",
    component: () => import("@/views/invited-parents/special-status/focus-failure/focus-failure.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "link-expired",
    name: "link-expired",
    component: () => import("@/views/invited-parents/special-status/link-expired/link-expired.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "info-failure",
    name: "info-failure",
    component: () => import("@/views/invited-parents/special-status/info-failure/info-failure.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "default-browser",
    name: "default-browser",
    component: () => import("@/views/invited-parents/default-browser/default-browser.vue"),
    meta: {
      title: "勤学好问-邀请家长"
    }
  },
  {
    path: "learning-report",
    name: "learning-report",
    component: () => import("@/views/monthly-report/learning-report.vue"),
    meta: {
      title: "学习报告",
      noCache: true
    }
  },
  {
    path: "ying-chun-bei",
    name: "ying-chun-bei",
    component: () => import("@/views/ying-chun-bei/ying-chun-bei.vue"),
    meta: {
      title: "活动详情"
    }
  },
  {
    path: "ying-chun-details",
    name: "ying-chun-details",
    component: () => import("@/views/ying-chun-bei/ying-chun-details.vue"),
    meta: {
      title: "准考证详情",
      noCache: true
    }
  },
  {
    path: "ying-chun-score-inquiry",
    name: "ying-chun-score-inquiry",
    component: () => import("@/views/ying-chun-bei/ying-chun-score-inquiry.vue"),
    meta: {
      title: "成绩查询",
      noCache: true
    }
  }
];
